import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-playeras',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './playeras.component.html',
  styleUrl: './playeras.component.scss'
})
export class PlayerasComponent implements OnInit {

  isModalOpen: boolean = false; 
  schemaJsonLd: string = '';
  
  // Estado para el acordeón (FAQ)
  faqState = [
    { open: false },
    { open: false },
    { open: false },
    { open: false }
  ];

  ngOnInit(): void {
    // Definición de esquemas JSON-LD (Service y FAQPage) enfocado en bordado y género
    this.schemaJsonLd = `[
      {
        "@context": "https://schema.org",
        "@type": "Service",
        "name": "Playeras Bordadas Personalizadas para Hombre y Mujer en México",
        "description": "Fábrica experta en personalización de Playeras para Hombre y Mujer exclusivamente con Bordado (Logo, Nombre y Parches). Ofrecemos la máxima durabilidad y Envío GRATIS en pedidos mayoristas a todo México. ¡Calidad superior garantizada!",
        "serviceType": "Bordado Textil de Lujo y Personalización de Uniformes",
        "areaServed": {
          "@type": "Country",
          "name": "México"
        },
        "provider": {
          "@type": "Organization",
          "name": "CAMBEN Bordado Premium"
        },
        "url": "https://[TU-DOMINIO]/playeras-bordadas-hombre-mujer"
      },
      {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": [
          {
            "@type": "Question",
            "name": "¿El servicio de bordado incluye logos, nombres y parches?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Sí. Somos especialistas en bordado de alta precisión. Ofrecemos la personalización completa de tus playeras (Hombre y Mujer) incluyendo logotipos empresariales, nombres individuales (identificación de staff) y parches bordados con diseño personalizado. Todo con máxima durabilidad."
            }
          },
          {
            "@type": "Question",
            "name": "¿Cómo puedo obtener Envío GRATIS en mis Playeras Bordadas?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Ofrecemos Envío GRATIS en todos los pedidos mayoristas (a partir de 30 unidades) a cualquier parte de México. Queremos asegurarte el mejor precio total y la mayor conveniencia."
            }
          },
          {
            "@type": "Question",
            "name": "¿Qué diferencia al Bordado CAMBEN de otros métodos de personalización?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Nos enfocamos en la durabilidad. El bordado es la técnica más resistente al lavado y al desgaste. Usamos hilos premium que no se decoloran, garantizando un acabado profesional y una vida útil 5 veces mayor que la serigrafía o la sublimación."
            }
          }
        ]
      }
    ]`;
  }

  toggleModal() {
    this.isModalOpen = !this.isModalOpen;
  }
  
  toggleFaq(index: number) {
    this.faqState[index].open = !this.faqState[index].open;
  }
}